<script setup lang="ts">
const props = defineProps<{
  data: SectionTeaserRecord
  moduleIndex: number
}>()

const { level, isSemantic, invertedStyles } = useSectionRules(
  props.moduleIndex,
  props.data.invertColorTheme,
  !!props.data.title
)

const id = useId()
const activeIdx = ref<number | null>(0)
</script>

<template>
  <div class="container overflow-hidden pb-15 pt-12 lg:pb-20 lg:pt-40" :class="invertedStyles">
    <div>
      <Heading
        v-if="data.title"
        class="mb-8 uppercase lg:mb-18"
        :level="level"
        :size="3"
        :is-semantic="isSemantic"
      >
        <TextReveal>{{ data.title }}</TextReveal>
      </Heading>
    </div>
    <section :aria-multiselectable="false">
      <ul
        role="tablist"
        aria-orientation="horizontal"
        class="mb-8 flex overflow-scroll lg:mb-12 lg:gap-10"
        data-lenis-prevent
      >
        <li v-for="(item, idx) in data.records" :key="idx" role="presentation">
          <Tab
            v-if="item.label"
            :id="`tab-${id}-label-${idx + 1}`"
            role="tab"
            :aria-controls="`tab-${id}-panel-${idx + 1}`"
            :aria-selected="activeIdx === idx"
            :aria-setsize="data.records.length"
            :aria-posinset="idx + 1"
            :is-active="activeIdx === idx"
            :invert-colors="data.invertColorTheme"
            :tabindex="activeIdx === idx ? 0 : -1"
            @click="activeIdx = idx"
            >{{ item.label }}</Tab
          >
        </li>
      </ul>
      <Teaser
        v-for="(item, idx) in data.records"
        v-show="activeIdx === idx"
        :id="`tab-${id}-panel-${idx + 1}`"
        :key="idx"
        :idx="idx"
        :data="item"
        :aria-hidden="activeIdx !== idx"
        :aria-labelledby="`tab-${id}-label-${idx + 1}`"
        role="tabpanel"
        tabindex="-1"
      />
    </section>
  </div>
</template>
